import { useState, useEffect } from 'react'
import { sueadicApi } from '../api/rrhh'

// Formato US (Presea + Excel del usuario): 1,234,567 — coma miles, sin decimales.
const fmt = (n) => (n == null || n === '' || isNaN(Number(n)))
  ? ''
  : Number(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })

// Paleta y tokens (alineados con SueAdicPage).
const C = {
  bg: '#f5f4f0',
  surface: '#ffffff',
  ink: '#1a1a1a',
  inkSoft: '#525252',
  inkMute: '#8a8a8a',
  border: '#e7e5e0',
  borderSoft: '#f0eeea',
  accent: '#1e3a8a',
  accentSoft: '#eef2ff',
  rowAlt: '#faf9f6',
}

export default function SueAdicEstadisticasPage() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [desglose, setDesglose] = useState(false)
  const [err, setErr] = useState('')

  useEffect(() => {
    sueadicApi.estadisticas()
      .then(({ data }) => setData(data))
      .catch(e => setErr(e.response?.data?.message || 'No se pudo cargar.'))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div style={st.page}><div style={st.container}><p style={{ color: C.inkMute }}>Cargando…</p></div></div>
  if (err) return <div style={st.page}><div style={st.container}><p style={{ color: '#991b1b' }}>{err}</p></div></div>
  if (!data) return null

  const { periodos, legajos, totales_periodo, total_global, adicionales_por_periodo } = data
  const totalAdicGlobal = Object.values(adicionales_por_periodo || {}).reduce((acc, v) => acc + (Number(v) || 0), 0)

  // Renderiza una celda de un período (1 td si desglose=off, 3 tds si on).
  const renderCelda = (celda) => {
    if (!desglose) {
      const v = celda?.total
      return <td style={st.tdTotal}>{v ? fmt(v) : ''}</td>
    }
    return (
      <>
        <td style={st.tdSub}>{celda?.banco ? fmt(celda.banco) : ''}</td>
        <td style={st.tdSub}>{celda?.extra ? fmt(celda.extra) : ''}</td>
        <td style={st.tdTotal}>{celda?.total ? fmt(celda.total) : ''}</td>
      </>
    )
  }

  return (
    <div style={st.page}>
    <div style={st.container}>
      <div style={st.head}>
        <div>
          <div style={st.eyebrow}>RRHH · Estadísticas</div>
          <h2 style={st.title}>Pago de sueldos · Historia</h2>
        </div>
        <div style={st.headRight}>
          <label style={st.toggleLbl}>
            <input type="checkbox" checked={desglose} onChange={e => setDesglose(e.target.checked)} />
            Mostrar desglose (banco + extra)
          </label>
        </div>
      </div>

      <div style={st.tablaWrap}>
        <div style={{ overflowX: 'auto', maxHeight: 'calc(100vh - 160px)', overflowY: 'auto' }}>
          <table style={st.table}>
            <thead>
              {/* Fila 1: nombres de mes (con colspan si desglose) */}
              <tr>
                <th rowSpan={2} style={{ ...st.thSticky, ...st.thLeg }}>Legajo</th>
                <th rowSpan={2} style={{ ...st.thSticky, ...st.thNom }}>Nombre</th>
                {periodos.map(p => (
                  <th key={p.id} colSpan={desglose ? 3 : 1} style={{ ...st.thSticky, ...st.thMes }}>
                    {p.etiqueta}
                    {p.estado === 'cerrado' && <span style={{ marginLeft: 4, fontSize: 9 }}>🔒</span>}
                  </th>
                ))}
                <th rowSpan={2} style={{ ...st.thSticky, ...st.thTotal }}>Total</th>
              </tr>
              {/* Fila 2: sub-encabezados banco/extra/total (solo si desglose) */}
              {desglose && (
                <tr>
                  {periodos.map(p => (
                    <>
                      <th key={`b-${p.id}`} style={st.thSub}>Banco</th>
                      <th key={`e-${p.id}`} style={st.thSub}>Extra</th>
                      <th key={`t-${p.id}`} style={st.thSubT}>Total</th>
                    </>
                  ))}
                </tr>
              )}
            </thead>
            <tbody>
              {legajos.map((l, i) => (
                <tr key={l.legajo} style={{ background: i % 2 === 1 ? C.rowAlt : C.surface }}>
                  <td style={{ ...st.tdSticky, ...st.tdLeg }}>{l.legajo}</td>
                  <td style={{ ...st.tdSticky, ...st.tdNom }}>{l.nombre}</td>
                  {periodos.map(p => {
                    const celda = l.celdas[p.id]
                    return desglose
                      ? <span key={p.id} style={{ display: 'contents' }}>{renderCelda(celda)}</span>
                      : renderCelda(celda)
                  })}
                  <td style={st.tdTotalRow}>{fmt(l.totales.total)}</td>
                </tr>
              ))}
              {legajos.length === 0 && (
                <tr><td colSpan={2 + periodos.length * (desglose ? 3 : 1) + 1} style={{ padding: 24, textAlign: 'center', color: C.inkMute }}>Sin datos.</td></tr>
              )}
              {/* Fila ADICIONALES — conceptos por pagador agrupados en una línea.
                  El valor cae en la columna EXTRA (es lo que se cobra fuera del
                  banco), suma a los totales del período. */}
              {totalAdicGlobal > 0 && (
                <tr style={{ background: C.borderSoft, fontStyle: 'italic' }}>
                  <td style={{ ...st.tdSticky, ...st.tdLeg }}></td>
                  <td style={{ ...st.tdSticky, ...st.tdNom, fontStyle: 'italic', color: C.inkSoft }}>Adicionales</td>
                  {periodos.map(p => {
                    const v = adicionales_por_periodo?.[p.id] || 0
                    return desglose
                      ? <span key={p.id} style={{ display: 'contents' }}>
                          <td style={st.tdSub}></td>
                          <td style={st.tdSub}>{v ? fmt(v) : ''}</td>
                          <td style={st.tdTotal}>{v ? fmt(v) : ''}</td>
                        </span>
                      : <td key={p.id} style={st.tdTotal}>{v ? fmt(v) : ''}</td>
                  })}
                  <td style={st.tdTotalRow}>{totalAdicGlobal ? fmt(totalAdicGlobal) : ''}</td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={2} style={{ ...st.tdFootLbl, ...st.tdSticky }}>TOTAL</td>
                {periodos.map(p => {
                  const t = totales_periodo[p.id] || { banco: 0, extra: 0, adicionales: 0, total: 0 }
                  return desglose
                    ? <span key={p.id} style={{ display: 'contents' }}>
                        <td style={st.tdFootSub}>{fmt(t.banco)}</td>
                        <td style={st.tdFootSub}>{fmt(t.extra)}</td>
                        <td style={st.tdFootTotal}>{fmt(t.total)}</td>
                      </span>
                    : <td key={p.id} style={st.tdFootTotal}>{fmt(t.total)}</td>
                })}
                <td style={st.tdFootGrand}>{fmt(total_global.total)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    </div>
  )
}

const st = {
  page: { background: C.bg, minHeight: '100vh', padding: '24px 32px', margin: '-16px -20px', boxSizing: 'border-box' },
  container: { maxWidth: 1480, margin: '0 auto' },

  head: { display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 12, paddingBottom: 14, borderBottom: `1px solid ${C.border}`, marginBottom: 18, flexWrap: 'wrap' },
  eyebrow: { fontSize: 10.5, fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: C.inkMute, marginBottom: 4 },
  title: { margin: 0, fontSize: 22, fontWeight: 700, color: C.ink, letterSpacing: '-0.01em' },
  headRight: { display: 'flex', alignItems: 'center', gap: 10 },
  toggleLbl: { display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5, color: C.inkSoft, cursor: 'pointer', background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, padding: '6px 12px', fontWeight: 600 },

  tablaWrap: { background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12, overflow: 'hidden' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 12 },

  thSticky: { background: C.surface, color: C.inkMute, fontWeight: 600, fontSize: 10, letterSpacing: '0.05em', textTransform: 'uppercase', padding: '8px 8px', textAlign: 'right', borderBottom: `1px solid ${C.border}`, borderRight: `1px solid ${C.borderSoft}`, position: 'sticky', top: 0, zIndex: 2 },
  thLeg: { textAlign: 'left', left: 0, zIndex: 3, minWidth: 60, width: 60 },
  thNom: { textAlign: 'left', left: 60, zIndex: 3, minWidth: 200 },
  thMes: { textAlign: 'center', borderLeft: `1px solid ${C.border}` },
  thTotal: { textAlign: 'right', borderLeft: `2px solid ${C.accent}`, color: C.accent, fontWeight: 700 },
  thSub: { background: C.surface, color: C.inkMute, fontWeight: 500, fontSize: 9.5, padding: '4px 8px', textAlign: 'right', borderBottom: `1px solid ${C.border}`, position: 'sticky', top: 24, zIndex: 2 },
  thSubT: { background: C.surface, color: C.accent, fontWeight: 700, fontSize: 9.5, padding: '4px 8px', textAlign: 'right', borderBottom: `1px solid ${C.border}`, borderRight: `1px solid ${C.border}`, position: 'sticky', top: 24, zIndex: 2 },

  tdSticky: { position: 'sticky', background: 'inherit', padding: '5px 8px', borderBottom: `1px solid ${C.borderSoft}`, borderRight: `1px solid ${C.borderSoft}`, zIndex: 1 },
  tdLeg: { left: 0, color: C.inkMute, fontWeight: 500, fontVariantNumeric: 'tabular-nums', textAlign: 'left' },
  tdNom: { left: 60, color: C.ink, fontWeight: 600, textAlign: 'left', whiteSpace: 'nowrap' },

  tdTotal: { padding: '5px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', borderBottom: `1px solid ${C.borderSoft}`, borderLeft: `1px solid ${C.borderSoft}`, fontWeight: 600, color: C.ink },
  tdSub: { padding: '5px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', borderBottom: `1px solid ${C.borderSoft}`, color: C.inkMute, fontWeight: 400 },
  tdTotalRow: { padding: '5px 10px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 700, color: C.accent, borderLeft: `2px solid ${C.accent}`, borderBottom: `1px solid ${C.borderSoft}` },

  tdFootLbl: { padding: '8px 10px', textAlign: 'left', fontWeight: 700, fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: C.inkSoft, background: C.bg, borderTop: `2px solid ${C.accent}`, position: 'sticky', bottom: 0, left: 0 },
  tdFootSub: { padding: '8px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 600, color: C.inkSoft, background: C.bg, borderTop: `2px solid ${C.accent}` },
  tdFootTotal: { padding: '8px 8px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 700, color: C.ink, background: C.bg, borderTop: `2px solid ${C.accent}`, borderLeft: `1px solid ${C.borderSoft}` },
  tdFootGrand: { padding: '8px 10px', textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 700, color: 'white', background: C.accent, borderTop: `2px solid ${C.accent}` },
}
